export type PatientReminder = {
  id: number;
  userId: string;
  patientId: number;
  reminderId: number;
};

export interface PatientReminderMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  getPatientReminders(): Promise<PatientReminder[]>;
  createPatientReminder(patRem: Omit<PatientReminder, 'id' | 'userId'>): Promise<PatientReminder>;
  updatePatientReminder(
    patRem: Partial<Omit<PatientReminder, 'id'>> & { id: number }
  ): Promise<PatientReminder>;
  deletePatientReminder(id: number): Promise<any>;
}
export const PatientReminderMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async getPatientReminders(): Promise<PatientReminder[]> {
    const res = await this.fetch(`/patient_reminders`, { method: 'get' });
    return res;
  },
  async createPatientReminder(
    patRem: Omit<PatientReminder, 'id' | 'userId'>
  ): Promise<PatientReminder> {
    const res = await this.fetch(`/patient_reminders`, {
      method: 'post',
      body: JSON.stringify({ ...patRem }),
    });
    return res;
  },
  async updatePatientReminder(
    patRem: Partial<Omit<PatientReminder, 'id'>> & { id: number }
  ): Promise<PatientReminder> {
    const res = await this.fetch(`/patient_reminders/${patRem.id}`, {
      method: 'put',
      body: JSON.stringify({ ...patRem }),
    });
    return res;
  },
  async deletePatientReminder(id: number): Promise<any> {
    const res = await this.fetch(`/patient_reminders/${id}`, { method: 'delete' });
    return res;
  },
} as PatientReminderMixin;
